module.exports = __webpack_public_path__ + "static/media/awox.63258ac0.jpg";